module.exports = __webpack_public_path__ + "img/empty-messages@2x.30ae0488.png";